/**
 * @generated SignedSource<<74ab872e039c4b0271595f06ea61b15d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileVerifiedBadge_profile$data = {
  readonly isVerified: boolean | null | undefined;
  readonly " $fragmentType": "ProfileVerifiedBadge_profile";
};
export type ProfileVerifiedBadge_profile$key = {
  readonly " $data"?: ProfileVerifiedBadge_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileVerifiedBadge_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileVerifiedBadge_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerified",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "154807fb6f8728fdb224184439414c75";

export default node;
